import React from 'react';
import AICallAnalysis from './AICallAnalysis';
import { InteractionData, SessionData } from './common/types';

interface Props {
    sessionDetails: SessionData[];
    aiCallAnalysis: InteractionData;
}

type FieldDef = { label: string; key: keyof SessionData };

const topFields: FieldDef[] = [
    { label: 'Session ID', key: 'SessionId' },
    { label: 'Started', key: 'Started' },
    { label: 'Duration', key: 'Duration' },
    { label: 'CSR', key: 'Agent Name' },
    { label: 'Skill', key: 'Skill' },
];

const detailFields: FieldDef[] = [
    { label: 'Primary Reason', key: 'PrimaryReason' },
    { label: 'Comments', key: 'Comment' },
    { label: 'Dispositions', key: 'Disposition' },
];

const KeyValueRow: React.FC<{ label: string; value: React.ReactNode; key: string }> = ({ label, value, key }) => (
    <div className={'session-details'} key={key}>
        <span className="title">{label}:</span>
        <span className="description">{value}</span>
    </div>
);

const InteractionDetails: React.FC<Props> = ({ sessionDetails, aiCallAnalysis }) => {
    return (
        <div className="interaction-details" data-testid="interaction-details">
            <div className="column-left" data-testid="column-left">
                {sessionDetails.map((session, idx) => {
                    return (
                        <div key={idx} className="session-card" data-testid={`session-card-${session.SessionId}`}>
                            <div
                                className="top-session-details"
                                data-testid={`top-session-details-${session.SessionId}`}
                            >
                                <div className="session-number" data-testid={`session-number-${session.SessionId}`}>
                                    {idx + 1}
                                </div>
                                {topFields.map(field => (
                                    <KeyValueRow
                                        key={`${session.SessionId}-${field.key}`}
                                        label={field.label}
                                        value={session[field.key]}
                                    />
                                ))}
                            </div>
                            {detailFields.map(field => (
                                <KeyValueRow
                                    key={`${session.SessionId}-${field.key}`}
                                    label={field.label}
                                    value={session[field.key]}
                                />
                            ))}
                        </div>
                    );
                })}
            </div>

            <AICallAnalysis aiCallAnalysis={aiCallAnalysis} />
        </div>
    );
};

export default InteractionDetails;
